module.exports = __webpack_public_path__ + "img/EXPORT.9e35fec5.svg";